import('./bootstrapper').then(({bootstrapper}) => {
    const v = bootstrapper.init();
    if(window.console) {
        console.log('app bootstrap completed - v' + v);
    }
});